import React from 'react';
import {ClinipamAppIconProps} from './types';

export const ClinipamAppIcon = ({size}: ClinipamAppIconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		style={{minWidth: size || 34}}
		viewBox="0 0 64 64"
		fill="none">
		<rect width="64" height="64" fill="#1539AA" />
		<path
			d="M14.5926 20.501C12.8907 23.4458 14.9044 27.0056 19.9916 28.9621C22.6561 29.9862 27.1111 30.2021 30.0173 29.4169C29.2464 26.5079 26.8365 22.755 24.6183 20.9558C20.3849 17.5232 16.2946 17.5561 14.5926 20.501Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9938 8.5C28.3054 8.5 26.0557 12.3215 26.9796 18.1597C27.4644 21.2175 29.6798 25.5182 31.9938 27.8194C34.3079 25.5167 36.5233 21.2175 37.0081 18.1597C37.9335 12.323 35.6823 8.5 31.9938 8.5Z"
			fill="#FF222B"
		/>
		<path
			d="M49.4094 20.511C47.7117 17.5647 43.6199 17.529 39.3837 20.9572C37.164 22.7521 34.7498 26.5036 33.9775 29.4126C36.8823 30.1993 41.3373 29.989 44.0032 28.9664C49.0919 27.0156 51.1084 23.4572 49.4094 20.511Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9938 44.5C34.2636 44.5 35.6494 42.1473 35.0802 38.5546C34.7813 36.6724 33.4183 34.0251 31.9938 32.6092C30.5694 34.0265 29.2064 36.6724 28.9075 38.5546C28.3383 42.1473 29.7241 44.5 31.9938 44.5Z"
			fill="#FFCC23"
		/>
		<path
			d="M19.7156 37.4848C20.8497 39.4513 23.58 39.4756 26.4075 37.1873C27.8892 35.9888 29.501 33.4859 30.0159 31.5422C28.0765 31.0173 25.1031 31.1575 23.324 31.8397C19.9273 33.1412 18.5814 35.5168 19.7156 37.4848Z"
			fill="#FF8800"
		/>
		<path
			d="M44.2735 37.4905C45.4091 35.5254 44.0661 33.1484 40.6709 31.8426C38.8917 31.1575 35.9183 31.0145 33.979 31.5394C34.4938 33.4816 36.1028 35.9859 37.5816 37.1873C40.4077 39.4785 43.1379 39.4571 44.2735 37.4905Z"
			fill="#FF8800"
		/>
		<path
			d="M26.75 47.5446H29.3618C29.7803 47.5446 30.1445 47.6221 30.4545 47.7771C30.7645 47.9321 31.0022 48.1491 31.1675 48.4281C31.338 48.7071 31.4233 49.03 31.4233 49.3968C31.4233 49.991 31.2347 50.456 30.8575 50.7918C30.4803 51.1276 29.9663 51.2956 29.3153 51.2956H27.8583V52.8611H26.75V47.5446ZM29.2378 50.3191C29.5581 50.3191 29.8061 50.2364 29.9818 50.0711C30.1574 49.9057 30.2453 49.6861 30.2453 49.4123C30.2453 49.1488 30.1574 48.9344 29.9818 48.7691C29.8061 48.6037 29.5581 48.5211 29.2378 48.5211H27.8583V50.3191H29.2378Z"
			fill="white"
		/>
		<path
			d="M32.3261 47.5446H35.0618C35.4855 47.5446 35.8523 47.6246 36.1623 47.7848C36.4775 47.945 36.7177 48.1671 36.8831 48.4513C37.0536 48.7303 37.1388 49.0455 37.1388 49.3968C37.1388 49.7326 37.0458 50.0581 36.8598 50.3733C36.6738 50.6833 36.4026 50.9132 36.0461 51.0631L37.4023 52.8611H36.0461L34.8758 51.2568H33.4343V52.8611H32.3261V47.5446ZM34.9146 50.2803C35.2401 50.2803 35.4958 50.2028 35.6818 50.0478C35.873 49.8928 35.9686 49.6784 35.9686 49.4046C35.9686 49.1411 35.8756 48.9292 35.6896 48.7691C35.5036 48.6037 35.2349 48.5211 34.8836 48.5211H33.4343V50.2803H34.9146Z"
			fill="white"
		/>
	</svg>
);
